export const generic_config = {
  socialLinks: [
    {type: "facebook", url:"https://www.facebook.com/profile.php?id=100088253478423",},
    {type: "twitter", url:"https://twitter.com/MyFortunaApps",},
    {type: "tiktok", url:"https://www.tiktok.com/@myfortunaapps",},
    {type: "linkedin", url:"https://www.linkedin.com/company/myfortuna",},
    // {pinterest: "",},
    // {instagram: "",},
  ],
}